















































































import {
  defineComponent, defineAsyncComponent, ref, onMounted, computed,
  onBeforeUnmount,
} from '@vue/composition-api';
import { Popup } from 'vant';
import { getSuperMemberCardSummary } from '@/api/rights/index';
import {
  SuperMemberSceneEnum, SuperCardSummaryBackType, SuperMemberSourceEnum,
  PackageBuyStatusEnum, RightPackageTypeEnum, SuperCardStyleTypeEnum, PayWayEnum,
} from '@/api/rights/types';
import { RightsPayInstance } from '@/shared/right-utils/rightsPay';
import {
  RIGHTS_DETAIL_POPUP_BUTTON,
  RIGHTS_AGREEMENT, RIGHTS_AGREEMENT_CHECK,
} from '@/shared/right-utils/ubtRights';
import { getSetupBusinessInfo, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { goBindBankCard } from '@/shared/right-utils/cardbind';
import { ForceReadService } from '@/widgets/right-contract';
import { ubtSendError } from '@/shared/utils/ubt';
import { ContractReadStatusEnum } from '@/widgets/right-contract/enum';

/** 够买成功遮罩层 */
const SuccessOverlayProfile = () => import(
  /* webpackChunkName: "async-success-overlay-profile" */ '@/widgets/rights/SuccessOverlay.vue'
);

const SuccessOverlay = defineAsyncComponent(SuccessOverlayProfile);

export default defineComponent({
  components: {
    Popup,
    SuccessOverlay,
  },
  props: {
    showBuyPopup: {
      type: Boolean,
      default: false,
    },
    isPatternA: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    /** 是否展示popuup */
    const showPopup = computed({
      get: () => props.showBuyPopup,
      set: (value) => {
        emit('update:showPopup', value);
      },
    });

    /** 接口返回时概要数据 */
    const superMemberCardSummaryList = ref<SuperCardSummaryBackType>({});

    /** 是否勾选 */
    const isChecked = ref<boolean>(false);

    /** 是否展示提示气泡 */
    const showBuyConfirm = ref<boolean>(false);

    /** 是否展示成功浮层 */
    const showSuccOverlay = ref<boolean>(false);

    /** 订单id */
    const orderId = ref<string>('');

    const {
      readStatus, handleForceRead, destroyInstance,
    } = ForceReadService({
      packageType: RightPackageTypeEnum.SUPER_MEMBER_CARD,
      forceReadFromScene: SuperMemberSourceEnum.MY_PROFILE,
    });

    /** 统一埋点参数上报 */
    const tqParams = computed(() => {
      const {
        packageId, packageType, supplierCode, sellPrice, packageName,
      } = superMemberCardSummaryList.value;
      return {
        packageId,
        packageName,
        packageType,
        supplierCode,
        sellPrice,
        from: SuperMemberSourceEnum.MY_PROFILE,
      };
    });

    /** 获取超级会员概要数据 */
    const superMemberCardSummary = async (): Promise<void> => {
      try {
        superMemberCardSummaryList.value = await getSuperMemberCardSummary({
          sceneType: SuperMemberSceneEnum.MY_PAGE,
        });
      } catch (e) {
        superMemberCardSummaryList.value = {};
        ubtSendError({ name: 'get_right_data_error', message: String(SuperMemberSceneEnum.MY_PAGE) });
      }
    };

    /** 变更勾选状态 */
    const changeChecked = async () => {
      const { contractInfo } = superMemberCardSummaryList.value;
      isChecked.value = !isChecked.value;
      /** 勾选状态为选中时上报 */
      if (isChecked.value) {
        ubtSetupPageButton(RIGHTS_AGREEMENT_CHECK, {
          ...tqParams.value,
          checkStatus: isChecked.value,
        });
        isChecked.value = await handleForceRead({
          contractScene: contractInfo?.scene || '',
          tqParams: tqParams.value,
        });
      }
    };

    /** 打开协议弹窗 */
    const openContract = async () => {
      /** 点击协议弹窗曝光 */
      ubtSetupPageButton(RIGHTS_AGREEMENT, tqParams.value);
      const { contractInfo } = superMemberCardSummaryList.value;
      if (contractInfo) {
        const handleRes = await handleForceRead({
          contractScene: contractInfo?.scene || '',
          tqParams: tqParams.value,
          preview: true,
        });
        if (handleRes) {
          isChecked.value = handleRes;
        }
      }
    };

    /** 去支付 */
    const goPay = async () => {
      // 这里只处理打点，不做任何接口层面的二次校验
      if (readStatus === ContractReadStatusEnum.NEED_READ_NOT_READ) {
        ubtSendError({
          name: 'right_force_read',
          message: 'needReadContract but not read',
          stack: SuperMemberSourceEnum.MY_PROFILE,
        });
      }

      ubtSetupPageButton(RIGHTS_DETAIL_POPUP_BUTTON, {
        action: 'agree',
        ...tqParams.value,
      });

      const {
        isSelectPayWay, packageId, packageType, payWay, sellPrice, contractInfo,
      } = superMemberCardSummaryList.value;
      if (!isSelectPayWay && !isChecked.value) {
        showBuyConfirm.value = true;
      } else {
        const payRes = await RightsPayInstance.H5pay({
          packageType: RightPackageTypeEnum.SUPER_MEMBER_CARD,
          packageId,
          needChoosePayWay: isSelectPayWay,
          contractInfo,
          payAmount: sellPrice,
          payWay,
          from: SuperMemberSourceEnum.MY_PROFILE,
          businessInfo: getSetupBusinessInfo(tqParams.value),
          goBindBankCard: ((options: { scene: string; bindCardApplySessionId: string; }) => {
            const {
              scene, bindCardApplySessionId,
            } = options;
            if (packageId) {
              goBindBankCard(
                SuperMemberSourceEnum.MY_COUPON,
                scene,
                packageId,
                bindCardApplySessionId,
                RightPackageTypeEnum.SUPER_MEMBER_CARD,
              );
            }
          }),
        });
        /** 成功回调 */
        if (payRes && payRes.status === 1) {
          orderId.value = payRes.orderId;
          showSuccOverlay.value = true;
        }
      }
    };

    /** 关闭弹窗 */
    const closePay = () => {
      ubtSetupPageButton(RIGHTS_DETAIL_POPUP_BUTTON, {
        action: 'disagree',
        ...tqParams.value,
      });
      isChecked.value = false;
      showPopup.value = false;
    };

    /** 更新遮罩层值 */
    const updateIsSuccOverlay = (value:boolean) => {
      showSuccOverlay.value = value;
    };

    /** 关闭开通成功蒙层回调 */
    const closeOverlay = () => {
      showPopup.value = false;
      emit('refreshData');
    };

    const payWayText = computed(() => {
      if (superMemberCardSummaryList.value
      && superMemberCardSummaryList.value.payWay === PayWayEnum.Card) {
        return '银行卡';
      }
      return '支付宝';
    });


    onMounted(() => {
      superMemberCardSummary();
    });

    onBeforeUnmount(() => {
      destroyInstance();
    });

    return {
      superMemberCardSummaryList,
      isChecked,
      showBuyConfirm,
      showSuccOverlay,
      PackageBuyStatusEnum,
      RightPackageTypeEnum,
      SuperCardStyleTypeEnum,
      showPopup,
      payWayText,
      orderId,

      changeChecked,
      openContract,
      closePay,
      goPay,
      updateIsSuccOverlay,
      closeOverlay,
    };
  },
});
